module.exports = __webpack_public_path__ + "img/PTT.84d98681.png";